var WebserviceRoute = {
  CLIENT_SIDE: 'wsvc',
  SERVER_SIDE: 'svc'
};
export default WebserviceRoute;